var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { CampaignService } from './campaign.service';
var CampaignTimingComponent = /** @class */ (function (_super) {
    __extends(CampaignTimingComponent, _super);
    function CampaignTimingComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.defMode = '';
        _this.readonly = false;
        _this.timing = new CampaignTiming();
        _this.data = new CampaignTimingData();
        return _this;
    }
    CampaignTimingComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    CampaignTimingComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (this.component.params && this.component.params.mode) {
            this.defMode = this.component.params.mode;
        }
        if (this.component.params && this.component.params.readonly === true) {
            this.readonly = true;
        }
    };
    CampaignTimingComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    CampaignTimingComponent.prototype.onSubscribe = function (data) {
        this.timing = new CampaignTiming();
        if (data.campaign_id) {
            this.timing.campaign_id = data.campaign_id;
        }
        if (this.timing.campaign_id) {
            this.getList(data.campaignTiming || data.campaign_timing);
        }
    };
    CampaignTimingComponent.prototype.onModeSubscribe = function (mode) {
        if (this.defMode !== mode) {
            this.action.deleteCompRec(this.componentName);
        }
    };
    CampaignTimingComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    CampaignTimingComponent.prototype.getList = function (timing) {
        var _this = this;
        this.data = new CampaignTimingData();
        this.service.getCampaignTimingTypeList(this.timing.campaign_id).subscribe(function (rec) {
            if (typeof rec !== 'undefined') {
                _this.data.type = [];
                for (var _i = 0, _a = rec.items; _i < _a.length; _i++) {
                    var item = _a[_i];
                    if (item.key === TimingType.trigger) {
                        _this.data.trigger_id = [];
                        for (var _b = 0, _c = item.data; _b < _c.length; _b++) {
                            var d = _c[_b];
                            _this.data.trigger_id.push({ code: d.key, display: d.label });
                        }
                    }
                    else if (item.key === TimingType.campaign) {
                        _this.data.target_campaign_id = [];
                        for (var _d = 0, _e = item.data; _d < _e.length; _d++) {
                            var d = _e[_d];
                            _this.data.target_campaign_id.push({
                                code: d.campaign_id,
                                display: d.title,
                                registry_type_id: d.registry_type_id,
                                registry_type_name: d.registry_type_name,
                                behavior_data: d.behavior_data
                            });
                        }
                    }
                    _this.data.type.push({ code: item.key, display: item.label });
                }
                _this.data.is_campaign_act = [];
                for (var _f = 0, _g = rec.campaignAct; _f < _g.length; _f++) {
                    var act = _g[_f];
                    _this.data.is_campaign_act.push({ code: (act.key === 'true'), display: act.label });
                }
            }
            if (timing) {
                _this.setTiming(timing);
            }
            // タイミング種別の1つ目をデフォルトとする
            if (!_this.timing.type && _this.data.type.length > 0) {
                _this.timing.type = _this.data.type[0].code;
            }
            _this.setTimingData();
        });
    };
    CampaignTimingComponent.prototype.setTiming = function (timing) {
        this.timing.type = timing.type;
        if (timing.type === 'specifydate') {
            this.timing.send_reserve_date = timing.send_reserve_date;
        }
        else if (timing.type === 'campaign') {
            this.timing = Object.assign(new CampaignTiming(), this.timing, {
                target_campaign_id: timing.target_campaign_id,
                registry_type_id: jsonpath.value(timing, '$.registryTypeM.registry_type_id'),
                registry_type_name: jsonpath.value(timing, '$.registryTypeM.label'),
                behavior_id: jsonpath.value(timing, '$.behaviorM.behavior_id'),
                is_campaign_act: timing.is_campaign_act,
                within_date: timing.within_date,
                elapsed_date: timing.elapsed_date
            });
            this.onChange({ key: 'target_campaign_id', val: timing.target_campaign_id });
        }
        else if (timing.type === 'trigger') {
            this.timing.trigger_id = jsonpath.value(timing, '$.triggerM.trigger_m_id');
        }
    };
    CampaignTimingComponent.prototype.changeType = function (type) {
        this.timing = Object.assign(new CampaignTiming(), { campaign_id: this.timing.campaign_id, type: type });
        this.setTimingData();
    };
    CampaignTimingComponent.prototype.changeTargetCampaign = function (data) {
        this.setBehaviorData(data);
        if (this.data.behavior_id.length > 0) {
            this.timing.behavior_id = this.data.behavior_id[0].code;
        }
        if (this.data.is_campaign_act.length > 0) {
            this.timing.is_campaign_act = this.data.is_campaign_act[0].code;
        }
        this.timing.registry_type_id = data.registry_type_id;
        this.timing.registry_type_name = data.registry_type_name;
    };
    CampaignTimingComponent.prototype.setBehaviorData = function (data) {
        this.data.behavior_id = [];
        for (var _i = 0, _a = data.behavior_data; _i < _a.length; _i++) {
            var d = _a[_i];
            this.data.behavior_id.push({ code: d.behavior_id, display: d.behavior_name });
        }
    };
    CampaignTimingComponent.prototype.onChange = function (e) {
        if (e.key === 'target_campaign_id' && e.val) {
            var data = jsonpath.value(this.data.target_campaign_id, '$..[?(@.code==' + e.val + ')]');
            if (e.val == this.timing.target_campaign_id) {
                this.setBehaviorData(data);
            }
            else {
                this.changeTargetCampaign(data);
            }
        }
        this.timing[e.key] = e.val;
        this.setTimingData();
    };
    CampaignTimingComponent.prototype.setTimingData = function () {
        var timing = Object.assign({}, this.timing);
        if (timing.registry_type_name) {
            delete timing.registry_type_name;
        }
        this.action.setCompRec(this.componentName, timing);
    };
    CampaignTimingComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'campaign-timing',
                    template: "<div *ngIf=\"defMode === mode\" id=\"{{ componentName }}\">\n  <div *ngIf=\"data.type && data.type.length > 0\" class=\"row -m-3\">\n    <div class=\"col-sm-12\">\n      <column [key]=\"'form'\" [col]=\"{\n        key: 'type',\n        controlType: 'radio',\n        required: true,\n        readonly: readonly,\n        params: { options: data.type }\n      }\" [val]=\"timing\" [msg]=\"(msg | async)\" (setChangeVal)=\"changeType($event.val)\"></column>\n    </div>\n  </div>\n  <horizontal-rule *ngIf=\"timing.type && timing.type !== 'immediate'\"></horizontal-rule>\n  <div *ngIf=\"timing.type === 'specifydate'\" class=\"row -m-3\">\n    <div class=\"col-sm-12\">\n      <column [key]=\"'form'\" [col]=\"{\n        key: 'send_reserve_date',\n        controlType: 'datetime',\n        readonly: readonly,\n        params: {placeholder: (msg | async)['Component.specifydate.placeholder']}\n      }\" [val]=\"timing\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n    </div>\n  </div>\n  <div *ngIf=\"timing.type === 'campaign'\" class=\"row -m-3\">\n    <div class=\"col-sm-12\">\n      <column [key]=\"'form'\" [col]=\"{\n        key: 'target_campaign_id',\n        controlType: 'select2',\n        readonly: readonly,\n        params: {\n          formClass: {width: '100per'},\n          placeholder: (msg | async)['CampaignTimingComponent.campaign.placeholder'],\n          options: data.target_campaign_id\n        }\n      }\" [val]=\"timing\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n    </div>\n  </div>\n  <ng-template [ngIf]=\"timing.type === 'campaign' && timing.target_campaign_id\">\n    <horizontal-rule></horizontal-rule>\n    <div class=\"row -m-3\">\n      <div class=\"col-sm-12\">\n        <column [key]=\"'form'\" [col]=\"{\n          label: (msg | async)['CampaignTimingComponent.campaign.measure'],\n          key: 'registry_type_name',\n          readonly: true\n        }\" [val]=\"timing\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n      </div>\n    </div>\n    <div class=\"row -m-3\">\n      <div class=\"col-sm-12\">\n        <column [key]=\"'form'\" [col]=\"{\n          label: (msg | async)['CampaignTimingComponent.campaign.behavior'],\n          key: 'behavior_id',\n          controlType: 'radio',\n          required: !readonly,\n          readonly: readonly,\n          params: {options: data.behavior_id}\n        }\" [val]=\"timing\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n      </div>\n    </div>\n    <div class=\"row -m-3\">\n      <div class=\"col-sm-12\">\n        <column [key]=\"'form'\" [col]=\"{\n          label: (msg | async)['CampaignTimingComponent.campaign.behaviorAct'],\n          key: 'is_campaign_act',\n          controlType: 'radio',\n          required: !readonly,\n          readonly: readonly,\n          params: {options: data.is_campaign_act}\n        }\" [val]=\"timing\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n      </div>\n    </div>\n    <div class=\"row -m-3\">\n      <div class=\"col-sm-12\">\n        <column [key]=\"'form'\" [col]=\"{\n          label: (msg | async)['CampaignTimingComponent.campaign.withinDate'],\n          readonly: readonly,\n          items: [{\n            label: (msg | async)['CampaignTimingComponent.campaign.withinDate.label1'],\n            controlType: 'label'\n          }, {\n            key: 'within_date',\n            controlType: 'number',\n            params: {options: { min: 0 }}\n          }, {\n            label: (msg | async)['CampaignTimingComponent.campaign.withinDate.label2'],\n            controlType: 'label'\n          }]\n        }\" [val]=\"timing\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n      </div>\n    </div>\n    <div class=\"row -m-3\">\n      <div class=\"col-sm-12\">\n        <column [key]=\"'form'\" [col]=\"{\n          label: (msg | async)['CampaignTimingComponent.campaign.elapsedDate'],\n          readonly: readonly,\n          items: [{\n            label: (msg | async)['CampaignTimingComponent.campaign.elapsedDate.label1'],\n            controlType: 'label'\n          }, {\n            key: 'elapsed_date',\n            controlType: 'number',\n            params: {options: { min: 0 }}\n          }, {\n            label: (msg | async)['CampaignTimingComponent.campaign.elapsedDate.label2'],\n            controlType: 'label'\n          }]\n        }\" [val]=\"timing\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n      </div>\n    </div>\n  </ng-template>\n  <div *ngIf=\"timing.type === 'trigger'\" class=\"row -m-3\">\n    <div class=\"col-sm-12\">\n      <column [key]=\"'form'\" [col]=\"{\n        key: 'trigger_id',\n        controlType: 'select2',\n        readonly: readonly,\n        params: {\n          formClass: {width: '100per'},\n          placeholder: (msg | async)['CampaignTimingComponent.trigger.placeholder'],\n          options: data.trigger_id\n        }\n      }\" [val]=\"timing\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n    </div>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    CampaignTimingComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: CampaignService }
    ]; };
    return CampaignTimingComponent;
}(ContentBaseComponent));
export { CampaignTimingComponent };
var CampaignTiming = /** @class */ (function () {
    function CampaignTiming() {
    }
    return CampaignTiming;
}());
var CampaignTimingData = /** @class */ (function () {
    function CampaignTimingData() {
        this.type = [];
        this.target_campaign_id = [];
        this.behavior_id = [];
        this.is_campaign_act = [];
        this.trigger_id = [];
    }
    return CampaignTimingData;
}());
export var TimingType;
(function (TimingType) {
    TimingType.immediate = 'immediate';
    TimingType.specifydate = 'specifydate';
    TimingType.campaign = 'campaign';
    TimingType.trigger = 'trigger';
})(TimingType || (TimingType = {}));
//# sourceMappingURL=campaign-timing.component.js.map